/**
 * Deterministic negative ID from a Supabase UUID.
 * Negative IDs never collide with local _allocId() (always positive),
 * preventing remote comments/approvals from silently shadowing local ones.
 */
export function uuidToNegId(uuid: string): number {
  let h = 0;
  for (let i = 0; i < uuid.length; i++) {
    h = ((h << 5) - h) + uuid.charCodeAt(i);
    h |= 0;
  }
  return h < 0 ? h : -h - 1;
}
